import { render, staticRenderFns } from "./PositionHeadForm.vue?vue&type=template&id=2e657753&"
import script from "./PositionHeadForm.vue?vue&type=script&lang=js&"
export * from "./PositionHeadForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports